import { TerminalStatus, TerminalStatusContext } from '../../../types/mf-execution.types'
import { AllStatusWrapper } from '../../../components/execution/terminal/AllStatusWrapper'
import { postCTA } from '../../../utils/appBridge'
import { getOrdersTabCTA } from '../../../utils/mutualFundDetail'

export const SIPPaymentFailedPage = () => {
  return (
    <div className='w-full h-screen relative overflow-hidden'>
      <AllStatusWrapper
        status={TerminalStatus.FAILURE}
        statusContext={TerminalStatusContext.SIP}
        failureConfig={{
          title: 'Payment failed',
          caption: 'Any amount deducted will be credited to <br /> source within 2-4 working days.',
          ctas: [
            {
              ctaType: 'primary',
              label: 'Go to dashboard',
              onClick: () => {
                // Handle navigation to dashboard
                console.log('Navigate to dashboard')
                postCTA(JSON.stringify(getOrdersTabCTA()))
              }
            }
          ]
        }}
      />
    </div>
  )
}
